import React, { Component } from 'react'
import CommonHeader from '../../navbars/CommonHeader';

// Analysis page header: the shared CommonHeader, in a colour of its own
// (page styles from .practice-exam-analysis-nav).
class TopNavbar extends Component {
    render() {
        return (
            <CommonHeader className="practice-exam-analysis-nav" color="auto" tone="light" container={false} onToggleSidebar={this.props.onClick} title={"Practise & Exam Analysis"} />
        )
    }
}

export default TopNavbar;
